module.exports = __webpack_public_path__ + "img/ico-check-circle.9eebcc30.svg";